<p-toast [style]="{ marginTop: '80px' }"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-treeTable  #pt [value]="inboxs" [paginator]="true" dataKey="msgId" selectionMode="single" [loading]="loading"
  [columns]="columns" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="msgId"
  (onNodeExpand)="onNodeExpand($event)" [rows]="25" [rowsPerPageOptions]="[25, 100, 200]" showCurrentPageReport="true"
  styleClass="p-datatable-striped"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  [tableStyle]="{'min-width':'50rem'}" [resizableColumns]="true" [autoLayout]="true" [scrollable]="true"
  [ngStyle]="{ width: 'auto' }" [(contextMenuSelection)]="selectedNode"
  [contextMenu]="gf"
  >
  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <span class="d-flex justify-content-between align-items-center">
        <!--add new-->
        <div>
          <p-selectButton [options]="mailBoxes" [(ngModel)]="selectedmailbox" (onChange)="loadMailBox($event)" optionLabel="label" optionValue="value">
            <ng-template let-item>
              <i [class]="item.icon"></i> &nbsp;&nbsp; {{item.label}}
            </ng-template>
          </p-selectButton>

        </div>
        <div class="ctmbutton">
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;  margin-right:10px;"
            (click)="onOpenFormAdd()">Compose
          Mail +</button>
          <!--refresh mails-->
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="refreshMails()">Refresh</button>
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="sendOutBoxMails()">SendOutBox Mail</button>
        </div>

      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th [ngStyle]="{'width': 'auto'}"></th>
      @for (col of columns; track col) {
        <th>
          {{ col.header }}
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}">Tags</th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th><p-multiSelect #aa [options]="inboxNames" [displaySelectedLabel]="true" display="chip"
        optionLabel="name" optionValue="imapConfigurationId" appendTo="body" (onChange)="pt.filter($event.value, 'ImapConfigurationVO.imapConfigurationId', 'in')"></p-multiSelect></th>
        <th>
          <!-- <p-dropdown #aa [options]="statuses" appendTo="body"
          (onChange)="pt.filter($event.value, 'status', 'in')" [style]="{'width':'50px','min-width':'100%'}"
          styleClass="p-column-filter" placeholder="Filter" [showClear]="true" optionLabel="name"
          optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown> -->
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
      type="text" (input)="pt.filter($event.target.value, 'senderName', 'in')" style="width:100px;"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
      type="text" (input)="pt.filter($event.target.value, 'senderEmail', 'in')" style="width:100px;"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
      type="text" (input)="pt.filter($event.target.value, 'subject', 'in')" style="width:100px;"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"><app-tag-join-filter-select [tagSource]="120" (getFilteredTags)="getFilteredTags($event)"></app-tag-join-filter-select></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  }
</ng-template>
<ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
  <tr [ttRow]="rowNode" [ttContextMenuRow]="rowNode" >
    <td>
      @if (getNumberOfChildMsg(rowData) > 0) {
        <p-treeTableToggler [rowNode]="rowNode"
        ></p-treeTableToggler>
      }
      @if (getNumberOfChildMsg(rowData) > 0) {
        <span>{{getNumberOfChildMsg(rowData)}}</span>
      }
    </td>
    @for (col of columns; track col; let i = $index) {
      <td (click)="onOpenFormEdit(rowData)" [ngStyle]="{'background-color': rowData.ischild ? '#d7eaef' : null}">
        {{ rowData[col.field] }}
      </td>
    }
    <td [ngStyle]="{'background-color': rowData.ischild ? '#D7EAEFFF' : null}" (click)="onOpenFormEdit(rowData)"><app-tag-join-list-select [tagSource]="120" [tagSourceId]="rowData.msgId" tagType="4"></app-tag-join-list-select></td>
    <td [ngStyle]="{'background-color': rowData.ischild ? '#D7EAEFFF' : null}"><span style="float:none">
      <a>
        <i class="pi pi-info" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
        (click)="onOpenFormEdit(rowData)"></i>
      </a>

      @if (rowData?.taskAPIList?.length>0) {
        <a>
          <i class="pi pi-check-square" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
          (click)="openViewTask(rowData)" title="View linked task"></i>
        </a>
      }
      @if (rowData?.taskAPIList?.length===0 || !rowData?.taskAPIList) {
        <a>
          <i class="pi pi-tablet" title="add task releated to this mail" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
          (click)="openCreatTask(rowData)"></i>
        </a>
      }
      @if (rowData?.msgId) {
        <a>
          <i class="pi pi-fw pi-download" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
          (click)="archiveMsg(rowData)" title="Arhive Mail"></i>
        </a>
      }
    </span>
  </td>
</tr>
</ng-template>
</p-treeTable>
<p-contextMenu #gf appendTo="body" [model]="items"></p-contextMenu>
